import type { AgeGroup } from 'models';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export const useGetUserAgeRange = () => {
  const { t } = useTranslation();

  return useCallback(
    ({ ageGroup }: { ageGroup: AgeGroup }) => {
      switch (ageGroup) {
        case '18_to_24':
        case '25_to_34':
        case '35_to_44':
        case '45_to_54':
        case '55_to_64':
        case '65_or_over':
        case 'under_18':
          return t(ageGroup);
        case null:
          return null;
      }
    },
    [t],
  );
};
